import React, { ReactNode } from "react"
import { Link } from "react-router-dom"
import styles from "./MenuItem.module.css"

interface MenuItemProps {
    to: string
    type: "spa" | "samedomain"
    isActive: boolean
    children: ReactNode
}

export function MenuItem({ to, children, type, isActive }: MenuItemProps) {
    const className = [
        "block no-underline text-white items-center flex flex-col p-4 opacity-75",
        styles.MenuItem,
        isActive ? styles.MenuItem_active : ""
    ].join(" ")

    switch (type) {
        case "samedomain":
            return (
                <a href={to} className={className}>
                    {children}
                </a>
            )
        default:
            return (
                <Link to={to} className={className}>
                    {children}
                </Link>
            )
    }
}
